// extracted by mini-css-extract-plugin
export default {"geofenceDetails":"GeofenceVersionTime_geofenceDetails__TCW9V"};